export default {
    birthday: {
        title: 'Anniversaires du mois'
    },
    employment: {
        title: 'Années de service'
    },
    messages: {
        birthday: '<strong>:NAME</strong> fête son anniversaire le :DAY :MONTH',
        employment: {
            started: '<strong>:NAME</strong> a commencé à l\'ODQ le :DATE',
            will_tart: '<strong>:NAME</strong> commencera à l\'ODQ le :DATE',
            years: '<strong>:NAME</strong> fête ses :YEARS an:S à l\'ODQ le :DATE'
        },
    }
}